import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 168 34"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#041C42",
  d: "M29.74 0h6.608v33.044H29.74V0Zm56.174 6.609h6.609v26.435h-6.609V6.609zM76 0h26.436v6.609H76V0zM0 0h6.609v33.044H0V0Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#041c42",
  d: "M11.565 0H.608v23.131h10.957c6.387 0 11.565-5.178 11.565-11.565S17.952.001 11.565.001z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#041C42",
  d: "M73.381 25.453c-2.94 4.567-8.068 7.591-13.902 7.591-9.125 0-16.522-7.397-16.522-16.522C42.957 7.397 50.354 0 59.479 0c5.835 0 10.963 3.024 13.902 7.591l-6.434 2.413a9.89 9.89 0 0 0-7.468-3.395c-5.475 0-9.914 4.438-9.914 9.913 0 5.475 4.439 9.913 9.914 9.913a9.89 9.89 0 0 0 7.469-3.395l6.433 2.413zm65.399-8.931c0 9.125-7.397 16.522-16.522 16.522s-16.522-7.397-16.522-16.522C105.736 7.397 113.133 0 122.258 0s16.522 7.397 16.522 16.522zm26.1-8.47 2.305-5.405C161.009-.965 155.548-.149 152.533.856c-3.016 1.004-5.26 4.717-5.647 8.334-.617 5.762 3.741 8.278 6.784 9.333 3.043 1.055 7.913 1.714 7.437 5.335-.369 2.799-2.799 3.186-5.655 3.23-3.172.047-6.787-3.4-6.787-3.4l-3.275 4.274c4.472 6.03 14.316 6.767 19.421 1.817 2.38-2.309 3.31-4.207 3.174-7.52-.219-5.318-6.572-8.064-9.218-8.474-2.646-.41-5.95-2.504-5.097-5.224.676-2.157 2.334-2.803 5.097-2.745 2.763.058 6.113 2.236 6.113 2.236z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }